import React, { useState } from 'react'
import { FiSearch } from 'react-icons/fi'
import './search.css'

const Search = ({ data, onFilter, startData }) => {
  const [searchTerm, setSearchTerm] = useState('')

  const handleInputChange = (event) => {
    const value = event.target.value
    setSearchTerm(value)

    const searchData = data.filter((item) =>
      item.name.toLowerCase().includes(value.toLowerCase())
    )

    const filteredResults = value.trim() === '' ? startData : searchData
    onFilter(filteredResults)
  }

  return (
    <div className="search-block">
      <label htmlFor="project-search" className="search-block__label">
        Найдите проект
      </label>
      <div className="search-field">
        <FiSearch className="search-field__icon" aria-hidden="true" />
        <input
          id="project-search"
          className="search-field__input"
          type="search"
          placeholder="Введите название проекта"
          autoComplete="off"
          value={searchTerm}
          onChange={handleInputChange}
        />
        <span className="search-field__underline" aria-hidden="true" />
      </div>
    </div>
  )
}

export default Search